export const hasAccess = function (feature, role, permissions, editMode) {
  if (!editMode) return false;

  if (!permissions.length) return permissions;

  return permissions.indexOf(feature) > -1;
}
